import { useState } from 'react';
import { Notice } from '@tcrd/ui';
import { api, errorMessage } from '../../lib/api';
import { useAuth } from '../../stores/auth';

/** "809 555 1234", "18095551234" o "+18095551234" → "+18095551234". null si no es válido. */
export function normalizePhone(raw: string): string | null {
  const plus = raw.trim().startsWith('+');
  const digits = raw.replace(/\D/g, '');
  let e164: string;
  if (plus) e164 = `+${digits}`;
  else if (digits.length === 10) e164 = `+1${digits}`; // número dominicano sin el 1
  else if (digits.length === 11 && digits.startsWith('1')) e164 = `+${digits}`;
  else return null;
  return /^\+[1-9]\d{7,14}$/.test(e164) ? e164 : null;
}

/**
 * Las cuentas creadas con Google no traen teléfono: antes de usar la app se pide el WhatsApp,
 * para que el conductor pueda contactar al cliente.
 */
export function PhoneGate() {
  const user = useAuth((s) => s.user);
  const reloadUser = useAuth((s) => s.reloadUser);
  const logout = useAuth((s) => s.logout);
  const [value, setValue] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!user || user.phone) return null;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const phone = normalizePhone(value);
    if (!phone) {
      setError('Escribe un número válido, por ejemplo 809 555 1234.');
      return;
    }
    setError(null);
    setBusy(true);
    try {
      await api('/users/me', { method: 'PATCH', body: { phone } });
      await reloadUser();
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div role="dialog" aria-modal="true" aria-labelledby="phone-gate-title" className="fixed inset-0 z-[100000] bg-[var(--surface)] overflow-y-auto">
      <div className="mx-auto w-full max-w-md px-5 pt-[calc(env(safe-area-inset-top)+3rem)] pb-12 flex flex-col gap-5">
        <h1 id="phone-gate-title" className="text-2xl font-semibold leading-snug">
          ¿Cuál es tu número de WhatsApp?
        </h1>
        <p className="text-[var(--text-muted)] -mt-2">Tu conductor lo usará para contactarte sobre tus viajes.</p>
        {error && <Notice tone="danger">{error}</Notice>}
        <form onSubmit={submit} className="flex flex-col gap-4" noValidate>
          <div className="flex h-14 rounded-xl bg-[var(--surface-2)] border-2 border-transparent focus-within:border-[var(--text)] transition-colors overflow-hidden">
            <span className="flex items-center pl-4 pr-2 text-base font-medium select-none">🇩🇴 +1</span>
            <input
              className="flex-1 min-w-0 bg-transparent pr-4 text-base outline-none"
              type="tel"
              inputMode="tel"
              autoComplete="tel-national"
              placeholder="809 555 1234"
              autoFocus
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </div>
          <button type="submit" className="tap w-full h-14 rounded-xl bg-black text-white dark:bg-white dark:text-black font-semibold disabled:opacity-50" disabled={busy || !value.trim()}>
            {busy ? 'Guardando…' : 'Continuar'}
          </button>
        </form>
        <button type="button" className="tap text-sm text-center underline text-[var(--text-muted)]" onClick={() => void logout()}>
          Salir
        </button>
      </div>
    </div>
  );
}
